module.exports = __webpack_public_path__ + "img/Rule.4a475775.png";